import {useQuery} from '@tanstack/react-query';

import {getAdminBanners, GetAdminBannersParams} from '../api';
import {QUERY__BANNERS} from '../queryKeys';
import {Banner} from '../types';

import {QueryOptionsForOne} from '@/shared/api';

export const useGetBanners = <SelectedData = Banner[]>(
  params?: GetAdminBannersParams,
  options?: QueryOptionsForOne<Banner[], SelectedData>,
) => {
  return useQuery({
    queryKey: [QUERY__BANNERS, params],
    queryFn: () => getAdminBanners(params),
    ...options,
  });
};
